export const minionFont = '"Minion", "Times New Roman", serif'
export const gillFont = '"GillSans", "Verdana", sans-serif'
export const tradeGothic = '"TradeGothic", "Verdana", sans-serif'
export const caflischFont = '"CaflischScriptPro", "Verdana", sans-serif'
